import { render, staticRenderFns } from "./Reschedule.vue?vue&type=template&id=2b9471ab&class=py-5&"
import script from "./Reschedule.vue?vue&type=script&lang=js&"
export * from "./Reschedule.vue?vue&type=script&lang=js&"
import style0 from "./Reschedule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports